/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PriceBookUsage } from '@gh/builder-shared-data';
import {
  AbstractSnapshotFormComponent,
  DateTimeTypes,
  EnumDictionary,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getRouteInitData,
} from '@gh/common-shared';
import { PbMasterInfo } from '../../../resources/price-book.model';
import { PbCommandService } from '../pb-command.service';

@Component({
  standalone: false,
  selector: 'gh-pb-details-top-form',
  templateUrl: 'pb-details-top-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PbDetailsTopFormComponent extends AbstractSnapshotFormComponent<PbMasterInfo> implements OnInit {
  priceBookUsages: EnumDictionary<PriceBookUsage>;

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder,
              private commandService: PbCommandService) {
    super();
  }

  ngOnInit(): void {
    const { priceBookUsages } = getRouteInitData(this.route);

    this.priceBookUsages = priceBookUsages;

    super.ngOnInit();
  }

  onLinkJstOpen(): void {
    this.commandService.openLinkJst();
  }

  onLinkCsmOpen(): void {
    this.commandService.openLinkCsm();
  }

  protected buildForm(snapshot: FormStateSnapshot<PbMasterInfo>): FormState<PbMasterInfo> {
    return this.formStateBuilder.buildPlain<PbMasterInfo>({
      snapshot,
      enabled: this.enabled,
      children: {
        name: { required: true },
        releaseDate: { required: true, type: DateTimeTypes.ShortDate },
        repriceDate: { enabled: false, type: DateTimeTypes.ShortDate },
        withdrawalDate: { required: true, type: DateTimeTypes.ShortDate },
        usage: { required: true },
      },
    });
  }
}
